/** Hindi: the agent screen and its cards, translation on the phone, and the rate card's source line. */
export const agent = {
    "agent.headline": "अपने एजेंट से बात करें।",
    "agent.soft": "आपके नोट यहीं रहते हैं।",
    "agent.placeholder": "बोलिए या लिखिए…",
    "agent.empty": "कुछ पूछिए, या इनमें से कुछ चुनिए।",
    "agent.suggest_rate": "मेरा रेट बदलें",
    "agent.suggest_earned": "इस हफ़्ते मैंने कितना कमाया?",
    "agent.earnings": "इस हफ़्ते आपको {week} मिले, और इस महीने {month}। अभी आने बाकी: {waiting}।",
    "agent.sources.one": "{count} नोट से",
    "agent.sources.other": "{count} नोटों से",
    "card.text": "एजेंट",
    "card.saved": "सेव हुआ",
    "card.answer": "जवाब",
    "card.draft": "ड्राफ़्ट",
    "card.needs_model": "मॉडल चाहिए",
    "card.clarify": "सवाल",
    "agent.clarify": "मुझे पक्का समझ नहीं आया कि आप क्या चाहते हैं। क्या आपका मतलब है:",
    "agent.thinking": "सोच रहा हूँ…",
    "choose.editCard": "मेरा कार्ड बदलें",
    "choose.helpOffer": "शहर में नए लोगों की मदद करें",
    "choose.helpStop": "नए लोगों की मदद बंद करें",
    "choose.moving": "मुझे दूसरे शहर जाना है",
    "choose.earnings": "मैंने कितना कमाया",
    "choose.market": "इस काम का रेट",
    "choose.guide": "नए शहर में बसना",
    "choose.find": "काम के लिए किसी को ढूँढें",
    "choose.remember": "इसे नोट में सेव करें",
    "choose.askSelf": "मेरे नोट्स में देखें",
    "choose.askContact": "मेरे संपर्क से पूछें",
    "choose.setRule": "मेरा संपर्क क्या देख सकता है",
    "choose.schedule": "मेरा शेड्यूल",
    "choose.chat": "कुछ और",
    "agent.saved": 'सेव किया: "{text}"',
    "agent.nothing": "इसके बारे में मेरे पास कुछ सेव नहीं है।",
    "agent.no_contact": "आपके संपर्कों में अभी {name} नहीं हैं।",
    "agent.ask_contact": '{name} से पूछें: "{text}"?',
    "agent.rules_later": 'मैं आपका कार्ड बदल सकता हूँ। बताइए क्या बदलना है, जैसे "मेरा रेट बदलो"।',
    "agent.market_later": "आस-पास के ग्राहक बोर्ड पर आपका कार्ड देखकर आपको ढूँढते हैं। नई रिक्वेस्ट 'आज' में दिखती हैं।",
    "agent.needs_model": "यह अभी इस फ़ोन पर नहीं हो सकता। मैं आपका कार्ड बना सकता हूँ और आपकी बातें याद रख सकता हूँ।",
    "said.translating": "इसी फ़ोन पर अनुवाद हो रहा है…",
    "said.cannot": "{lang} में। यह फ़ोन अभी इसका अनुवाद नहीं कर सकता।",
    "said.unsafe": "{lang} में। अनुवाद में कोई अंक बदल गया, इसलिए नहीं दिखाया।",
};
//# sourceMappingURL=agent.js.map